export default __webpack_public_path__ + "static/media/completion-modal-bg.33ddcb8c.png";